import { AppContainerProps } from './AppContainer.types'
import AppContainerWrapper from './AppContainer.styles'
import AppHeader from '../AppHeader'
import AppBody from '../AppBody'
import AppFooter from '../AppFooter'

const AppContainer = ({
  header,
  body,
  footer,
  children,
  styles
}: AppContainerProps) => {
  const {
    components: headerComponents,
    show: headerShow = true,
    ...headerProps
  } = header || {}
  const {
    components: footerComponents,
    show: footerShow = true,
    ...footerProps
  } = footer || {}
  const { components: bodyComponents, ...bodyProps } = body || {}

  return (
    <AppContainerWrapper data-testid="app-container" sx={styles}>
      {!!headerComponents && headerShow && (
        <AppHeader
          className="AppHeader"
          data-testid="app-header"
          {...headerProps}>
          {headerComponents}
        </AppHeader>
      )}
      {!!bodyComponents && (
        <AppBody className="AppBody" {...bodyProps}>
          {bodyComponents}
        </AppBody>
      )}
      {!!footerComponents && footerShow && (
        <AppFooter
          className="appFooter"
          data-testid="app-footer"
          {...footerProps}>
          {footerComponents}
        </AppFooter>
      )}
      {children}
    </AppContainerWrapper>
  )
}

export default AppContainer
